import { memo } from "react";
import { motion, useReducedMotion } from "framer-motion";

const PILL_SPRING = { type: "spring", stiffness: 520, damping: 42, mass: 0.9 };
const HIDE_TRANSITION = { duration: 0 };

const SidebarActivePill = ({ pill }) => {
  const prefersReducedMotion = useReducedMotion();
  const { x = 0, y = 0, width = 0, height = 0, opacity = 0 } = pill || {};
  const hidden = opacity < 0.01 || width < 2 || height < 2;

  return (
    <motion.div
      className={"sidebar-active-pill" + (hidden ? " is-hidden" : "")}
      aria-hidden="true"
      initial={false}
      animate={{ x, y, width, height, opacity: hidden ? 0 : opacity }}
      transition={
        prefersReducedMotion || hidden ? HIDE_TRANSITION : PILL_SPRING
      }
      style={
        hidden
          ? { visibility: "hidden", pointerEvents: "none", boxShadow: "none" }
          : undefined
      }
    />
  );
};

export default memo(SidebarActivePill);
